import type { ServiceCategoryInterface } from '@models/service/service-category.interface';
import type { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class ServiceCategoryWebService {
  readonly #httpClient = inject(HttpClient);

  readonly #api = `${environment.api.externalService}/external-services/categories`;
  readonly #apiAdmin = `${environment.api.externalService}/admin/category`;

  getAll(): Observable<ServiceCategoryInterface[]> {
    return this.#httpClient.get<ServiceCategoryInterface[]>(this.#api);
  }

  create(serviceCategory: ServiceCategoryInterface): Observable<void> {
    return this.#httpClient.post<undefined>(this.#apiAdmin, { name: serviceCategory.name });
  }

  update(serviceCategory: ServiceCategoryInterface): Observable<void> {
    return this.#httpClient.put<undefined>(`${this.#apiAdmin}/${serviceCategory.id}`, { name: serviceCategory.name });
  }
}
